import { SortByOptions } from './../../../core/models/general.model';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { ResultsContainer } from '../results.container';
import { Angulartics2 } from 'angulartics2';
@Component({
  selector: 'app-results-sidebar',
  templateUrl: 'sidebar.component.html',
  styleUrls: ['sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnChanges {
  currentRate = 1;
  prevRate = 0;
  constructor(private resultsContainer: ResultsContainer, private angulartics2: Angulartics2) { }

  @Input() mealTypes;
  @Input() hotelTypes;
  // @Input() exclusiveCategories;
  // @Input() optionalFacilities;
  @Input() experiences;
  @Input() minPrice;
  @Input() maxPrice;
  @Input() minPriceOffer;
  @Input() maxPriceOffer;
  @Input() stickySidebar;
  @Input() fullScreenWindowOptions;

  defaultRange = [this.minPrice, this.maxPrice];
  defaultRangeOffers = [this.minPriceOffer, this.maxPriceOffer];

  selecteOption = 'price_high_low';
  // @Input() offersEnabled;
  selectedOptionTexts = {
    price_high_low: 'Price high to low',
    price_low_high: 'Price low to high',
    stars: 'Stars',
    special_offer: 'Special offer expires in',
    exclusives: 'Experiences'
  };

  activeFilters: {
    mealTypes: Array<number>;
    hotelTypes: Array<number>;
    exclusiveCategories: Array<number>;
    optionalFacilities: Array<number>;
    experiences: Array<number>;
    priceRange: Array<number>;
    stars: number;
    offerType: string;
  };

  mobileFullsreenWindow = {
    isSortByOpen: false,
    isFilterOptionsOpen: false,
    isMapOpen: false
  };

  @Output() filterResults: EventEmitter<any> = new EventEmitter();
  @Output() filterOffers: EventEmitter<any> = new EventEmitter();
  @Output() closeFullScreenWindow: EventEmitter<any> = new EventEmitter();
  @Output() filterExp: EventEmitter<any> = new EventEmitter();

  someRange = [this.minPrice, this.maxPrice];
  someRangeOffers = [this.minPriceOffer, this.maxPriceOffer];
  minPriceOfferSlider = 0;
  maxPriceOfferSlider = 0;
  expToFilter: String;

  ngOnInit() {
    this.someRange = [this.minPrice, this.maxPrice];
    this.someRangeOffers = [this.minPriceOffer, this.maxPriceOffer];
    this.minPriceOfferSlider = this.minPriceOffer;
    this.maxPriceOfferSlider = this.maxPriceOffer;
    this.activeFilters = {
      hotelTypes: new Array(),
      mealTypes: new Array(),
      exclusiveCategories: new Array(),
      optionalFacilities: new Array(),
      experiences: new Array(),
      priceRange: new Array(),
      stars: 0,
      offerType: 'Hotel'
    };
    this.onChangeFilter('price_high_low');
  }

  ngOnChanges() {
    if (this.someRange[0] === this.defaultRange[0] && this.someRange[1] === this.defaultRange[1]) {
      return;
    } else {
      this.someRange = [this.minPrice, this.maxPrice];
    }
    if (this.someRangeOffers[0] === this.defaultRangeOffers[0] && this.someRangeOffers[1] === this.defaultRangeOffers[1]) {
      return;
    } else {
      this.someRangeOffers = [this.minPriceOffer, this.maxPriceOffer];
    }
  }

  changeOfferType() {
    // this.offersEnabled = !this.offersEnabled;
    this.filterbyOfferType();
  }

  getKeys(mapObj) {
    return Array.from(mapObj.keys());
  }

  getIcon(id) {
    switch (id) {
      case 1:
        return 'icon-aircondition';
      case 5:
        return 'icon-gym';
      case 22:
        return 'icon-family';
      case 30:
        return 'icon-beach';
      case 31:
        return 'icon-food';
      case 43:
        return 'icon-parking';
      case 46:
        return 'icon-wifi';
      case 132:
        return 'icon-pet-friendly';
      default:
        return 'icon-facility';

    }
  }

  isUserLoggedIn() {
    return this.resultsContainer.isLoggedIn$;
  }

  filterbyOfferType() {
    /*if (this.offersEnabled) {
      this.activeFilters.offerType = 'Offer';
    } else {
      this.activeFilters.offerType = 'Hotel';
    } */
    this.activeFilters.offerType = 'Hotel';
    this.filterResults.emit([SortByOptions.SORT_BY_HOTEL_TYPE, this.activeFilters]);
  }

  filterbyHotelType(hotelid) {
    const index = this.activeFilters.hotelTypes.indexOf(hotelid);
    if (index > -1) { this.activeFilters.hotelTypes.splice(index, 1); } else {
      this.activeFilters.hotelTypes.push(hotelid);
    }

    this.filterResults.emit([SortByOptions.SORT_BY_HOTEL_TYPE, this.activeFilters]);
  }

  filterbyMealType(id) {
    const index = this.activeFilters.mealTypes.indexOf(id);
    if (index > -1) { this.activeFilters.mealTypes.splice(index, 1); } else {
      this.activeFilters.mealTypes.push(id);
    }

    this.filterResults.emit([SortByOptions.SORT_BY_MEAL_TYPE, this.activeFilters]);
  }

  filterbyExclusive(id) {
    const index = this.activeFilters.exclusiveCategories.indexOf(id);
    if (index > -1) { this.activeFilters.exclusiveCategories.splice(index, 1); } else {
      this.activeFilters.exclusiveCategories.push(id);
    }
    this.filterResults.emit([SortByOptions.SORT_BY_EXCLUSIVE_CAT, this.activeFilters]);
  }

  filterbyExperience(id) {
    const index = this.activeFilters.experiences.indexOf(id);
    if (index > -1) { this.activeFilters.experiences.splice(index, 1); } else {
      this.activeFilters.experiences.push(id);
    }
    this.filterResults.emit([SortByOptions.SORT_BY_EXPERIENCE, this.activeFilters]);
  }

  filterbyOptional(id) {
    const index = this.activeFilters.optionalFacilities.indexOf(id);
    if (index > -1) { this.activeFilters.optionalFacilities.splice(index, 1); } else {
      this.activeFilters.optionalFacilities.push(id);
    }
    this.filterResults.emit([SortByOptions.SORT_BY_OPTIONAL_CAT, this.activeFilters]);
  }

  onChange(x) { }

  onChangeOfferFilter(x) {
    this.minPriceOffer = x[0];
    this.maxPriceOffer = x[1];
  }

  filterByPrice() {
    this.activeFilters.priceRange = this.someRange;
    this.filterResults.emit([SortByOptions.SORT_BY_PRICE, this.activeFilters]);
  }

  filterByPriceOffers() {
    this.filterOffers.emit([this.someRangeOffers]);
  }

  filterByExpOffers(exp: any) {
    this.expToFilter = exp;
    this.filterExp.emit(this.expToFilter);
  }

  filterByStars() {
    if (this.prevRate === this.currentRate) {
      this.prevRate = this.currentRate - 1;
      this.activeFilters.stars = this.prevRate;
    } else {
      this.prevRate = this.currentRate;
      this.activeFilters.stars = this.prevRate;
    }
    this.filterResults.emit([SortByOptions.SORT_BY_PRICE, this.activeFilters]);
  }


  closeFilterWindow(event) {
    if (event === 'closeFilters') {
      this.mobileFullsreenWindow.isFilterOptionsOpen = false;
      document.getElementById('filterSidebar').style.width = '0';
    } else if (event === 'closeSortBy') {
      this.mobileFullsreenWindow.isSortByOpen = false;
      document.getElementById('filterSidebar').style.width = '0';
    } else if (event === 'map') {
      this.mobileFullsreenWindow.isMapOpen = false;
      document.getElementById('right').style.width = '0';
    }
  }

  onChangeFilter(option) {
    if (option.target) {
      option = option.target.value;
    }

    this.angulartics2.eventTrack.next({ action: option });

    switch (option) {
      case 'price_low_high': {
        this.filterResults.emit([SortByOptions.SORT_BY_PRICE_ASC, this.activeFilters]);
        break;
      }
      case 'price_high_low': {
        this.filterResults.emit([SortByOptions.SORT_BY_PRICE_DESC, this.activeFilters]);
        break;
      }
      case 'stars': {
        this.filterResults.emit([SortByOptions.SORT_BY_STARS, this.activeFilters]);
        break;
      }
      case 'exclusives': {
        this.filterResults.emit([SortByOptions.SORT_BY_EXCLUSIVE_CAT, this.activeFilters]);
        break;
      }
      case 'optional': {
        break;
      }
      default: {
        this.filterResults.emit([SortByOptions.SORT_BY_PRICE_ASC, this.activeFilters]);
      }
    }

    this.closeNav('closeSortBy');
  }

  closeNav(eventType) {
    this.closeFullScreenWindow.emit(eventType);
  }

}
